import React from "react";
import Navigation from "../components/navigation/Navigation";
import { Outlet } from "react-router-dom";
import { parseJwt } from "../components/utilities/utils";
// import Logobar from "../components/Logobar/Logobar";
function WithNav() {
  let userName = localStorage.access_token
  ? parseJwt(localStorage.access_token).name
  : null;
  return (
    <>
      {/* <Logobar /> */}
      <Navigation 
       userName={userName}
       label1={"Electronically Transmitted"}
       label2={"Postal Ballot Management System (ETPBMS)"}/>
      <Outlet />
    </>
  );
}

export default WithNav;
